module.exports = __webpack_public_path__ + "static/img/ic-close.2de9926c.svg";